var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{ active: _vm.isVisible }},[_c('div',{staticClass:"modal-content",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"loading-spinner"}),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }